import AccessDeniedLayer from '../components/AccessDeniedLayer';
import { useAuth } from '../context/AuthContext';
import { Outlet } from 'react-router-dom';

export default function ProtectedApp() {
    const { authenticated, user, isLoading } = useAuth();
    
    // Logs para debug
    // console.log('ProtectedApp - authenticated:', authenticated);
    // console.log('ProtectedApp - user:', user);
    // console.log('ProtectedApp - isLoading:', isLoading);
    
    // Se ainda está carregando a verificação inicial, mostra loading
    if (isLoading) {
        // console.log('ProtectedApp - Mostrando loading...');
        return <>Carregando...</>;
    }
    
    // Se está autenticado e tem dados do usuário, mostra o conteúdo
    if (authenticated && user) {
        // console.log('ProtectedApp - Usuário autenticado, mostrando conteúdo');
        return <Outlet />;
    }
    
    // Se não está autenticado, mostra a tela de acesso negado
    // console.log('ProtectedApp - Usuário não autenticado, mostrando Access Denied');
    return <AccessDeniedLayer />;
}
